<stages-common-index [ngClass]="getClasses()" [entries]="(childrenEntries$ | async)!" />
